"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostcodeLocationAttributes$ = exports.PostcodeLocationAttributes$outboundSchema = exports.PostcodeLocationAttributes$inboundSchema = void 0;
exports.postcodeLocationAttributesToJSON = postcodeLocationAttributesToJSON;
exports.postcodeLocationAttributesFromJSON = postcodeLocationAttributesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const geopointlocation_js_1 = require("./geopointlocation.js");
const postcodepolygonattributes_js_1 = require("./postcodepolygonattributes.js");
/** @internal */
exports.PostcodeLocationAttributes$inboundSchema = z.object({
    local_authority_district_code: z.nullable(z.string()),
    local_authority_district_name: z.nullable(z.string()),
    postcode_location: geopointlocation_js_1.GeoPointLocation$inboundSchema,
    postcode_polygons: z.nullable(postcodepolygonattributes_js_1.PostcodePolygonAttributes$inboundSchema),
    recorded: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "local_authority_district_code": "localAuthorityDistrictCode",
        "local_authority_district_name": "localAuthorityDistrictName",
        "postcode_location": "postcodeLocation",
        "postcode_polygons": "postcodePolygons",
    });
});
/** @internal */
exports.PostcodeLocationAttributes$outboundSchema = z.object({
    localAuthorityDistrictCode: z.nullable(z.string()),
    localAuthorityDistrictName: z.nullable(z.string()),
    postcodeLocation: geopointlocation_js_1.GeoPointLocation$outboundSchema,
    postcodePolygons: z.nullable(postcodepolygonattributes_js_1.PostcodePolygonAttributes$outboundSchema),
    recorded: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        localAuthorityDistrictCode: "local_authority_district_code",
        localAuthorityDistrictName: "local_authority_district_name",
        postcodeLocation: "postcode_location",
        postcodePolygons: "postcode_polygons",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PostcodeLocationAttributes$;
(function (PostcodeLocationAttributes$) {
    /** @deprecated use `PostcodeLocationAttributes$inboundSchema` instead. */
    PostcodeLocationAttributes$.inboundSchema = exports.PostcodeLocationAttributes$inboundSchema;
    /** @deprecated use `PostcodeLocationAttributes$outboundSchema` instead. */
    PostcodeLocationAttributes$.outboundSchema = exports.PostcodeLocationAttributes$outboundSchema;
})(PostcodeLocationAttributes$ || (exports.PostcodeLocationAttributes$ = PostcodeLocationAttributes$ = {}));
function postcodeLocationAttributesToJSON(postcodeLocationAttributes) {
    return JSON.stringify(exports.PostcodeLocationAttributes$outboundSchema.parse(postcodeLocationAttributes));
}
function postcodeLocationAttributesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PostcodeLocationAttributes$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PostcodeLocationAttributes' from JSON`);
}
//# sourceMappingURL=postcodelocationattributes.js.map